// extracted by mini-css-extract-plugin
module.exports = {"Decor":"decor_Decor__3sxPs"};